export default __webpack_public_path__ + "static/media/circle-placeholder.e0af734d.svg";